interface LegendProps {
  legend: {
    label: string;
    value: string;
  }[];
}

function WidgetLegend({ legend }: LegendProps) {
  return (
    <div
      className={`${
        legend.length > 3 ? 'grid grid-cols-2' : 'flex '
      } mb-6  w-max rounded-sm border border-black-100 bg-black-50 px-4 py-2 md:flex `}
    >
      {legend.map((item, index) => (
        <p
          key={item.label}
          className={`${
            legend.length > 3 &&
            '[&:nth-child(3)]:!border-l-0 [&:nth-child(3)]:pl-0  lg:[&:nth-child(3)]:!border-l' +
              ' lg:[&:nth-child(3)]:px-2.5'
          } lg:not-first:border-l  border-black-300 px-2.5 first:pl-0 `}
        >
          <span className="text-black-600">{item.label}</span>
          <span className="ml-1 font-semibold">{item.value}</span>
        </p>
      ))}
    </div>
  );
}

export default WidgetLegend;
